import { render } from "./costs-center.vue?vue&type=template&id=b8d55ae4&scoped=true"
import script from "./costs-center.vue?vue&type=script&lang=js"
export * from "./costs-center.vue?vue&type=script&lang=js"

import "./costs-center.vue?vue&type=style&index=0&id=b8d55ae4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d55ae4"]])

export default __exports__